import React, { useEffect, useState, useCallback } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, IconButton, Grid,
    TableSortLabel, CircularProgress, Backdrop, FormControl, InputLabel, Select, MenuItem, TextField,
    Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Typography, Box, FormControlLabel,
    Checkbox
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PrintIcon from '@mui/icons-material/Print';
import api from '../../services/api';
import InputMask from 'react-input-mask';
import buscarCEP from '../../utils/BuscarCEP';
import ExportExcelButton from '../../utils/ExportExcel';

const Inscricoes = () => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');
    const [dialogMessage, setDialogMessage] = useState('');
    const [registros, setRegistros] = useState([]);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('nome');
    const [loading, setLoading] = useState(false);
    const [imprimiuFilter, setImprimiuFilter] = useState('N');
    const [dataInicioFilter, setDataInicioFilter] = useState('');
    const [dataFimFilter, setDataFimFilter] = useState('');
    const [cpfFilter, setCpfFilter] = useState('');
    const [nomeFilter, setNomeFilter] = useState('');
    const [turmaFilter, setTurmaFilter] = useState(0);
    const [respFilter, setRespFilter] = useState('');
    const [deleteId, setDeleteId] = useState(null);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [registroAtual, setRegistroAtual] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [cursos, setCursos] = useState([]);
    const [turmas, setTurmas] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [openTurmaModal, setOpenTurmaModal] = useState(false);
    const [novaTurmaSelecionada, setNovaTurmaSelecionada] = useState('');
    const [novoCursoSelecionado, setNovoCursoSelecionado] = useState('');

    const [emailError, setEmailError] = useState(false);

    const handleFilterChange = useCallback(() => {
        // Construir o objeto de filtros com os valores atuais
        const imprimiuValue = imprimiuFilter === "Todos" ? "" : imprimiuFilter;
        const filters = {
            imprimiu: imprimiuValue,
            dataInicio: dataInicioFilter,
            dataFim: dataFimFilter,
            cpf: cpfFilter,
            nome: nomeFilter,
            respLegal: respFilter,
            turma: turmaFilter
        };

        // Fazer uma nova requisição ao backend com os filtros aplicados
        fetchInscricoes(filters);
    }, [imprimiuFilter, cpfFilter, dataFimFilter, dataInicioFilter, nomeFilter, respFilter, turmaFilter]);

    useEffect(() => {
        fetchCursos();
        handleFilterChange();
    }, [handleFilterChange]);

    const sexos = [
        { label: 'Feminino', value: 'F' },
        { label: 'Masculino', value: 'M' }
    ];

    const estados = [
        { label: 'Acre', value: 'AC' },
        { label: 'Alagoas', value: 'AL' },
        { label: 'Amapá', value: 'AP' },
        { label: 'Amazonas', value: 'AM' },
        { label: 'Bahia', value: 'BA' },
        { label: 'Ceará', value: 'CE' },
        { label: 'Distrito Federal', value: 'DF' },
        { label: 'Espírito Santo', value: 'ES' },
        { label: 'Goiás', value: 'GO' },
        { label: 'Maranhão', value: 'MA' },
        { label: 'Mato Grosso', value: 'MT' },
        { label: 'Mato Grosso do Sul', value: 'MS' },
        { label: 'Minas Gerais', value: 'MG' },
        { label: 'Pará', value: 'PA' },
        { label: 'Paraíba', value: 'PB' },
        { label: 'Paraná', value: 'PR' },
        { label: 'Pernambuco', value: 'PE' },
        { label: 'Piauí', value: 'PI' },
        { label: 'Rio de Janeiro', value: 'RJ' },
        { label: 'Rio Grande do Norte', value: 'RN' },
        { label: 'Rio Grande do Sul', value: 'RS' },
        { label: 'Rondônia', value: 'RO' },
        { label: 'Roraima', value: 'RR' },
        { label: 'Santa Catarina', value: 'SC' },
        { label: 'São Paulo', value: 'SP' },
        { label: 'Sergipe', value: 'SE' },
        { label: 'Tocantins', value: 'TO' }
    ];

    const etnias = [
        { label: 'Amarela', value: '1' },
        { label: 'Branca', value: '2' },
        { label: 'Indigena', value: '3' },
        { label: 'Negra', value: '4' },
        { label: 'Parda', value: '5' },
        { label: 'Não Declarante', value: '6' }
    ];

    const deficiencias = [
        { label: 'Não Possui', value: '1' },
        { label: 'Auditiva', value: '2' },
        { label: 'Física', value: '3' },
        { label: 'Visual', value: '4' },
        { label: 'Intelectual', value: '5' },
        { label: 'Múltipla', value: '6' },
        { label: 'Altas habilidades', value: '7' },
        { label: 'Consultas típicas', value: '8' },
        { label: 'Outras', value: '9' }
    ];

    const ocupacoes = [
        { label: 'Autônomo', value: '1' },
        { label: 'Empregado com carteira', value: '2' },
        { label: 'Empregado sem carteira', value: '3' },
        { label: 'Empregador', value: '4' },
        { label: 'Profissional Liberal', value: '5' },
        { label: 'Desempregado em busca 1° emprego', value: '6' },
        { label: 'Desempregado', value: '7' },
        { label: 'Aposentado', value: '8' },
    ];

    const niveisEnsino = [
        { label: 'Ensino Fundamental', value: '1' },
        { label: 'Ensino Médio', value: '2' },
        { label: 'Ensino Superior', value: '3' },
    ];

    const escolas = [
        { label: 'Estadual', value: '1' },
        { label: 'Municipal', value: '2' },
        { label: 'Particular', value: '3' },
        { label: 'SENAI', value: '4' },
        { label: 'SESI', value: '5' },
        { label: 'Federal', value: '6' },
    ];

    const handleOpenTurmaModal = () => {
        setNovaTurmaSelecionada('');
        setNovoCursoSelecionado('');
        setOpenTurmaModal(true);
    };

    const handleCloseTurmaModal = () => {
        setOpenTurmaModal(false);
    };

    const handleConfirmarTurma = async () => {
        try {
            //console.log(novaTurmaSelecionada,novoCursoSelecionado);
            //if (!novaTurmaSelecionada || !novoCursoSelecionado) return;

            const payload = {
                registros: selectedRows,
                idTurma: novaTurmaSelecionada || '0',
                idCurso: novoCursoSelecionado || '0'
            };

            const response = await api.post('/inscricoes/atualizarTurma', payload);

            if (response.data.success) {
                setDialogTitle('Sucesso');
                setDialogMessage('Curso e turma atribuídos com sucesso!');
                setDialogOpen(true);
                handleCloseTurmaModal();
                fetchInscricoes(); // Atualizar os registros na tela
            } else {
                setDialogTitle('Erro');
                setDialogMessage('Erro ao atribuir curso e turma.');
                setDialogOpen(true);
            }
        } catch (error) {
            console.error('Erro ao atualizar curso e turma:', error);
            setDialogTitle('Erro');
            setDialogMessage('Erro ao atualizar curso e turma.');
            setDialogOpen(true);
        }
    };



    // Selecionar ou desmarcar uma única linha
    const handleSelectRow = (id) => {
        setSelectedRows((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((rowId) => rowId !== id) // Remove se já estiver selecionado
                : [...prevSelected, id] // Adiciona se não estiver selecionado
        );
    };

    // Selecionar ou desmarcar todas as linhas
    const handleSelectAllRows = (event) => {
        if (event.target.checked) {
            const allIds = registros.map((r) => r.id); // Pega todos os IDs
            setSelectedRows(allIds);
        } else {
            setSelectedRows([]); // Limpa a seleção
        }
    };

    const handleCepChange = async (e) => {
        const { name, value } = e.target;
        setRegistroAtual({ ...registroAtual, [name]: value });

        if (value.length === 9) {
            try {
                const address = await buscarCEP(value);
                setRegistroAtual({
                    ...registroAtual,
                    cep: value,
                    rua: address.logradouro,
                    bairro: address.bairro,
                    municipio: address.localidade,
                    estado: address.uf
                });
            } catch (error) {
                console.error("Erro ao buscar endereço: ", error);
            }
        }
    };

    const handleEmailChange = (e) => {
        setRegistroAtual({ ...registroAtual, email: e.target.value.toLowerCase() });
        if (validateEmail(e.target.value)) {
            setEmailError(false);
        } else {
            setEmailError(true);
        }
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };


    const fetchCursos = async () => {
        try {
            const response = await api.get('/cursos/list'); // Faz a requisição para obter os cursos
            const cursosTemp = [{ id: 0, descricao: '[A ESCOLHER]' }, ...response.data];
            setCursos(cursosTemp); // Armazena os cursos no estado
        } catch (error) {
            console.error('Erro ao buscar cursos:', error);
        }


        try {
            const response = await api.get('/turmas/list?ativo=S'); // Faz a requisição para obter as turmas
            const turmasTemp = [{ id: 0, descricao: '[TODAS]' }, ...response.data];
            setTurmas(turmasTemp); // Armazena as turmas no estado
        } catch (error) {
            console.error('Erro ao buscar turmas:', error);
        }
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleDeleteClick = (id) => {
        setDeleteId(id);
        setOpenDeleteDialog(true); // Abre o diálogo de confirmação
    };

    const handleCancelDelete = () => {
        setOpenDeleteDialog(false);
        setDeleteId(null);
    };


    const handleConfirmDelete = async () => {
        try {
            await api.delete(`/inscricoes/${deleteId}`);
            handleFilterChange();
            setOpenDeleteDialog(false); // Fecha o diálogo
            setDeleteId(null); // Limpa o ID de exclusão
        } catch (error) {
            console.error('Erro ao deletar inscrição', error);
            setDialogTitle('Erro');
            setDialogMessage('Erro ao deletar inscrição');
            setDialogOpen(true);
        }
    };

    const fetchInscricoes = async (filters = {}) => {
        try {
            const response = await api.get('/inscricoes/list', { params: filters });
            const data = response.data;
            setRegistros(data);
            console.log(data);
        } catch (error) {
            console.error('Erro ao buscar inscritos', error);
        }
    };

    const handleRequestSort = (property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const sortedRegisters = registros.sort((a, b) => {
        if (orderBy === 'id') {
            return order === 'asc' ? a.id - b.id : b.id - a.id;
        } else {
            return order === 'asc'
                ? String(a[orderBy]).localeCompare(String(b[orderBy]))
                : String(b[orderBy]).localeCompare(String(a[orderBy]));
        }
    });

    const handleNome = (e) => {
        const { name, value } = e.target;
        if (name === 'nome') {
            setNomeFilter(value.toUpperCase());
        } else if (name === 'respFilter') { // Use o name correto para "Responsável / Empresa"
            setRespFilter(value.toUpperCase());
        }

    }

    const handlePrint = async (id) => {
        // Chama o endpoint no backend e abre o PDF em uma nova aba
        try {
            setLoading(true); // Inicia o indicador de carregamento
            const response = await api.get(`/inscricoes/pdf/${id}`, { responseType: 'blob' });
            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');
            setRegistros((prevRegistros) =>
                prevRegistros.map((registro) =>
                    registro.id === id ? { ...registro, imprimiu: 'S' } : registro
                )
            );
            setLoading(false); // Finaliza o indicador de carregamento
        } catch (error) {
            setLoading(false); // Finaliza o indicador de carregamento
            console.error('Erro ao gerar PDF', error);
            setDialogTitle('Erro');
            setDialogMessage('Erro ao gerar PDF');
            setDialogOpen(true);
        }
    };

    // Função para gerar todos os PDFs em lote
    const handlePrintAll = async () => {
        try {
            setLoading(true);
            const ids = registros.map((r) => r.id); // Coleta todos os IDs da tabela
            const response = await api.post(`/inscricoes/pdflote`, { ids }, { responseType: 'blob' });

            const pdfBlob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(pdfBlob);
            window.open(pdfUrl, '_blank');

            setLoading(false);
        } catch (error) {
            setLoading(false);
            console.error('Erro ao gerar PDFs em lote', error);
            setDialogTitle('Erro');
            setDialogMessage('Erro ao gerar PDFs em lote.');
            setDialogOpen(true);
        }
    };

    const handleEditClick = (r) => {
        setRegistroAtual(r);
        setIsEditMode(true);
        setOpenEditDialog(true);
    };

    const handleChange = (e) => {
        const name = e.target.name;
        let value = e.target.value;

        if (typeof value === 'string') {
            value = value.toUpperCase();
        }
        setRegistroAtual({ ...registroAtual, [name]: value });
        if (name === 'cpf') {
            //validarCPF(value,false);
        }
    };

    const handleCheckboxChange = (e, field) => {
        const isChecked = e.target.checked;

        if (field === 'concluido') {
            // Se marcar "Concluído", desmarca "Cursando"
            setRegistroAtual({
                ...registroAtual,
                ensinoConcluido: isChecked,
                ensinoCursando: !isChecked ? registroAtual.ensinoCursando : false, // Desmarca o outro campo se marcado
                ensinoCursandoAno: isChecked ? registroAtual.ensinoCursandoAno : '', // Reseta anoConclusao se desmarcar
                ensinoCursandoSerie: ''
            });
        } else if (field === 'cursando') {
            // Se marcar "Cursando", desmarca "Concluído"
            setRegistroAtual({
                ...registroAtual,
                ensinoCursando: isChecked,
                ensinoConcluido: !isChecked ? registroAtual.ensinoConcluido : false, // Desmarca o outro campo se marcado
                serieCursando: isChecked ? registroAtual.serieCursando : '', // Reseta serieCursando se desmarcar
                ensinoConcluidoAno: ''
            });
        }
    };

    const handleSaveRegistro = async () => {

        if (isEditMode) {
            try {
                await api.put(`/inscricoes/${registroAtual.id}`, registroAtual);
                handleFilterChange(); // Atualizar a lista
            } catch (error) {
                console.error('Erro ao atualizar registro', error);
            }
        }

        setOpenEditDialog(false);
        setRegistroAtual({});
    };

    const nomeTurma = (idTurma) => {
        const turma = turmas.find((t) => t.id === idTurma);
        return turma ? turma.descricao : ' ';
    };

    const registrosExcel = () => {
        const dataToExport = registros.map((registro) => ({
            Nome: registro.nome,
            Turma: nomeTurma(registro.idTurma),
            Celular: registro.celular
        }));
        return dataToExport;
    }

    const PdfButton = ({ data }) => {
        /*const printPdf = () => {
            data.map((r) => {
                handlePrint(r.id);
            })
        }*/
        const printPdf = () => {
            handlePrintAll();
        }

        return (
            <button
                onClick={() => printPdf()}
                style={{
                    backgroundColor: '#E2574C',
                    color: 'white',
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '16px'
                }}>
                Gerar PDF Todos
            </button>
        );
    }

    const TrocarTurmaButton = () => {
        return (
            <button
                variant="contained"
                color='secondary'
                //onClick={() => console.log('IDs selecionados:', selectedRows)}
                onClick={handleOpenTurmaModal}
                disabled={selectedRows.length === 0}
                style={{
                    backgroundColor: '#9400D3',
                    color: 'white',
                    padding: '10px 20px',
                    border: 'none',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    fontSize: '16px'
                }}
            >
                Trocar Turma
            </button>
        )
    }

    return (
        <div style={{ marginTop: 80 }}>
            <Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{ marginBottom: 20 }} sx={{ maxWidth: '95%', margin: 'auto' }}>
                <Grid item >
                    <TextField
                        label="Nome"
                        name="nome"
                        value={nomeFilter}
                        onChange={handleNome}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item>
                    <InputMask
                        mask="999.999.999-99"
                        value={cpfFilter}
                        onChange={(e) => setCpfFilter(e.target.value)}
                    >
                        {() => (
                            <TextField
                                label="CPF"
                                name="cpf"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                sx={{ width: '155px' }}
                            />
                        )}
                    </InputMask>
                </Grid>

                <Grid item>
                    <FormControl sx={{ minWidth: 100 }}>
                        <InputLabel id="imprimiu-label" sx={{ fontSize: '1rem', color: 'black' }}>Imprimiu?</InputLabel>
                        <Select
                            labelId="imprimiu-label"
                            value={imprimiuFilter}
                            onChange={(e) => setImprimiuFilter(e.target.value)}
                            label="Imprimiu?"
                        >
                            <MenuItem value="N">Não</MenuItem>
                            <MenuItem value="S">Sim</MenuItem>
                            <MenuItem value="Todos">Todos</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item>
                    <TextField
                        label="Responsavel / Empresa"
                        name="respFilter"
                        value={respFilter}
                        onChange={handleNome}
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item >
                    <FormControl sx={{ minWidth: 130 }}>
                        <InputLabel id="turma-label" sx={{ fontSize: '1rem', color: 'black' }}>Turma</InputLabel>
                        <Select
                            labelId="turma-label"
                            name="turmaFilter"
                            value={turmaFilter}
                            onChange={(e) => setTurmaFilter(e.target.value)}
                            label="Turma"
                        >
                            {turmas.map((c) => (
                                <MenuItem key={c.id} value={c.id}>
                                    {c.descricao}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item >
                    <TextField
                        label="Data Cadastro Início"
                        type="date"
                        value={dataInicioFilter}
                        onChange={(e) => setDataInicioFilter(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item>
                    <TextField
                        label="Data Cadastro Fim"
                        type="date"
                        value={dataFimFilter}
                        onChange={(e) => setDataFimFilter(e.target.value)}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item>
                    <Button variant="contained" color="primary" onClick={handleFilterChange}>
                        FILTRAR
                    </Button>
                </Grid>
            </Grid>

            <TableContainer component={Paper} sx={{ maxWidth: '95%', margin: 'auto' }}>

                <Grid container alignItems="center" justifyContent="flex-end" spacing={2} style={{ marginBottom: 16 }}>
                    <Typography variant="h6">
                        Total de registros exibidos: {registros.length}
                    </Typography>
                    <Grid item>
                        <ExportExcelButton data={registrosExcel()} />
                    </Grid>
                    <Grid item>
                        <PdfButton data={sortedRegisters} />
                    </Grid>
                    {selectedRows.length > 0 && (
                        <Grid item>
                            <TrocarTurmaButton />
                        </Grid>
                    )}
                </Grid>
                <Table>
                    <TableHead sx={{ backgroundColor: 'red' }}>
                        <TableRow>
                            <TableCell>
                                <Checkbox
                                    indeterminate={selectedRows.length > 0 && selectedRows.length < registros.length}
                                    checked={selectedRows.length === registros.length}
                                    onChange={handleSelectAllRows}
                                />
                            </TableCell>
                            <TableCell sx={{ color: 'white' }}>ID</TableCell>
                            <TableCell sx={{ color: 'yellow' }}>
                                <TableSortLabel
                                    active={orderBy === 'nome'}
                                    direction={orderBy === 'nome' ? order : 'asc'}
                                    onClick={() => handleRequestSort('nome')}
                                >
                                    Nome
                                </TableSortLabel>
                            </TableCell>
                            <TableCell sx={{ color: 'white' }}>CPF</TableCell>
                            <TableCell sx={{ color: 'yellow' }}>
                                <TableSortLabel
                                    active={orderBy === 'dtInsc'}
                                    direction={orderBy === 'dtInsc' ? order : 'asc'}
                                    onClick={() => handleRequestSort('dtInsc')}
                                >
                                    Dt.Cadastro
                                </TableSortLabel>
                            </TableCell>
                            <TableCell sx={{ color: 'white' }}>Nome da Turma</TableCell>
                            <TableCell sx={{ color: 'white' }}>Imprimiu?</TableCell>
                            <TableCell sx={{ color: 'white' }}>Ações</TableCell>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {sortedRegisters.map((r) => (
                            <TableRow key={r.id}>
                                <TableCell>
                                    <Checkbox
                                        checked={selectedRows.includes(r.id)}
                                        onChange={() => handleSelectRow(r.id)}
                                    />
                                </TableCell>
                                <TableCell>{r.id}</TableCell>
                                <TableCell>{r.nome}</TableCell>
                                <TableCell>{r.cpf}</TableCell>
                                <TableCell>{r.dtCadastro}</TableCell>
                                <TableCell>{nomeTurma(r.idTurma)}</TableCell>
                                <TableCell>{r.imprimiu}</TableCell>
                                <TableCell>
                                    <IconButton onClick={() => handlePrint(r.id)} ><PrintIcon /></IconButton>
                                    <IconButton ><EditIcon onClick={() => handleEditClick(r)}></EditIcon></IconButton>
                                    <IconButton ><DeleteIcon onClick={() => handleDeleteClick(r.id)} /></IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog
                open={dialogOpen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dialogMessage}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="primary" autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openDeleteDialog}
                onClose={handleCancelDelete}
            >
                <DialogTitle>Confirmar Exclusão</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Você tem certeza que deseja deletar este inscrito? Esta ação não pode ser desfeita.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelDelete} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleConfirmDelete} color="secondary">
                        Deletar
                    </Button>
                </DialogActions>
            </Dialog>

            {/*Diágolo de troca de truma*/}

            <Dialog open={openTurmaModal} onClose={handleCloseTurmaModal}
                maxWidth="md" // Permite um tamanho médio
                fullWidth
                PaperProps={{
                    sx: {
                        minWidth: "400px", // Define a largura mínima
                        maxWidth: "600px" // Define um tamanho máximo para não expandir demais
                    }
                }}
            >
                <DialogTitle>Selecionar Turma</DialogTitle>
                <DialogContent>
                    {/* Seleção de Curso */}
                    <FormControl fullWidth sx={{ marginBottom: 2 }}>
                        <InputLabel>Curso</InputLabel>
                        <Select
                            value={novoCursoSelecionado}
                            onChange={(e) => setNovoCursoSelecionado(e.target.value)}
                        >
                            {cursos.map((curso) => (
                                <MenuItem key={curso.id} value={curso.id}>
                                    {curso.descricao}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth>
                        <InputLabel>Turma</InputLabel>
                        <Select
                            value={novaTurmaSelecionada}
                            onChange={(e) => setNovaTurmaSelecionada(e.target.value)}
                        >
                            {turmas.map((turma) => (
                                <MenuItem key={turma.id} value={turma.id}>
                                    {turma.descricao}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseTurmaModal} color="secondary">
                        Cancelar
                    </Button>
                    <Button onClick={handleConfirmarTurma} color="primary" >
                        Confirmar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Diálogo de alteração */}
            <Dialog open={openEditDialog}
                onClose={() => setOpenEditDialog(false)}
                maxWidth="lg" // Definindo o tamanho máximo
                fullWidth // Garante que ocupe a largura

            >
                <DialogTitle>{isEditMode ? 'Editar ' : 'Novo '}</DialogTitle>
                <DialogContent>
                    <Box sx={{ my: 4 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={8} >
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Nome do Curso</InputLabel>
                                    <Select
                                        label="Nome do Curso"
                                        name="idCurso"
                                        value={registroAtual.idCurso} // Troca para idCurso
                                        onChange={handleChange}
                                        required
                                    >
                                        {cursos.map((c) => (
                                            <MenuItem key={c.id} value={c.id}>
                                                {c.descricao}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={4}>

                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Turma</InputLabel>
                                    <Select
                                        label="Turma"
                                        name="idTurma"
                                        value={registroAtual.idTurma}
                                        onChange={handleChange}
                                        required
                                    >
                                        {turmas.map((c) => (
                                            <MenuItem key={c.id} value={c.id}>
                                                {c.descricao}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Dados Pessoais */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Dados Pessoais</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Nome Completo Civil"
                                    name="nomeCivil"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.nomeCivil}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={8} >
                                <TextField
                                    label="Nome Completo Social"
                                    name="nomeSocial"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.nomeSocial}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <InputMask
                                    mask="99/99/9999"
                                    value={registroAtual.dtNasc}
                                    onChange={handleChange}
                                >
                                    {() => (
                                        <TextField
                                            label="Data de Nascimento"
                                            name="dataNascimento"
                                            variant="outlined"
                                            fullWidth
                                            required
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Documento de Identidade"
                                    name="docId"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.docId}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    label="Órgão"
                                    name="docOrgao"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.docOrgao}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>UF</InputLabel>
                                    <Select
                                        label="UF"
                                        name="docUF"
                                        value={registroAtual.docUF}
                                        onChange={handleChange}
                                    >
                                        {estados.map((estado) => (
                                            <MenuItem key={estado.value} value={estado.value}>
                                                {estado.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <InputMask
                                    mask="999.999.999-99"
                                    value={registroAtual.cpf}
                                    onChange={handleChange}
                                >
                                    {() => (
                                        <TextField
                                            label="CPF"
                                            name="cpf"
                                            variant="outlined"
                                            fullWidth
                                            required

                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Sexo</InputLabel>
                                    <Select
                                        label="Sexo"
                                        name="sexo"
                                        value={registroAtual.sexo}
                                        onChange={handleChange}
                                        required
                                    >
                                        {sexos.map((sex) => (
                                            <MenuItem key={sex.value} value={sex.value}>
                                                {sex.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Nacionalidade"
                                    name="nacionalidade"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.nacionalidade}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Naturalidade"
                                    name="naturalidade"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.naturalidade}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>UF</InputLabel>
                                    <Select
                                        label="UF"
                                        name="naturalidadeUF"
                                        value={registroAtual.naturalidadeUF}
                                        onChange={handleChange}
                                    >
                                        {estados.map((estado) => (
                                            <MenuItem key={estado.value} value={estado.value}>
                                                {estado.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Pai"
                                    name="pai"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.pai}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    label="Mãe"
                                    name="mae"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.mae}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Etnia</InputLabel>
                                    <Select
                                        label="Etnia"
                                        name="etnia"
                                        value={registroAtual.idEtnia}
                                        onChange={handleChange}
                                        required
                                    >
                                        {etnias.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </Grid>
                            <Grid item xs={12}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Deficiência e Necessidades Educacionais Especiais</InputLabel>
                                    <Select
                                        label="Deficiência e Necessidades Educacionais Especiais"
                                        name="deficiencia"
                                        value={registroAtual.idDef}
                                        onChange={handleChange}
                                        required
                                    >
                                        {deficiencias.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* Situação Ocupacional */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Situação Ocupacional</Typography>

                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Situação Ocupacional</InputLabel>
                                    <Select
                                        label="Situação Ocupacional"
                                        name="situacaoOcupacional"
                                        value={registroAtual.idSitOcupacional}
                                        onChange={handleChange}
                                        required
                                    >
                                        {ocupacoes.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Endereço */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Endereço</Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <InputMask
                                    mask="99999-999"
                                    value={registroAtual.cep}
                                    onChange={handleCepChange}
                                >
                                    {() => (
                                        <TextField
                                            label="CEP"
                                            name="cep"
                                            variant="outlined"
                                            fullWidth
                                            required
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    label="Rua / Avenida"
                                    name="rua"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.endereco}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <TextField
                                    label="Nº"
                                    name="numero"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.numero}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="Bairro"
                                    name="bairro"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.bairro}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="Município"
                                    name="municipio"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.cidade}
                                    onChange={handleChange}
                                    required
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Estado</InputLabel>
                                    <Select
                                        label="Estado"
                                        name="estado"
                                        value={registroAtual.uf}
                                        onChange={handleChange}
                                        required
                                    >
                                        {estados.map((estado) => (
                                            <MenuItem key={estado.value} value={estado.value}>
                                                {estado.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={3}>
                                <InputMask
                                    mask="(99) 9999-9999"
                                    value={registroAtual.fone}
                                    onChange={handleChange}
                                >
                                    {() => (
                                        <TextField
                                            label="Telefone"
                                            name="fone"
                                            variant="outlined"
                                            fullWidth

                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={3}>
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={registroAtual.celular}
                                    onChange={handleChange}
                                >
                                    {() => (
                                        <TextField
                                            label="Celular"
                                            name="celular"
                                            variant="outlined"
                                            fullWidth
                                            required
                                        />
                                    )}
                                </InputMask>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField
                                    label="E-mail"
                                    name="email"
                                    type="email"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.email}
                                    onChange={handleEmailChange}
                                    required
                                    error={emailError}
                                    helperText={emailError ? 'Por favor, insira um email válido.' : ''}
                                />
                            </Grid>

                            {/* Escolaridade */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Escolaridade</Typography>
                            </Grid>
                            <Grid item xs={3}>

                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Escolaridade</InputLabel>
                                    <Select
                                        label="Escolaridade"
                                        name="escolaridade"
                                        value={registroAtual.idEscolaridade}
                                        onChange={handleChange}
                                        required
                                    >
                                        {niveisEnsino.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid item xs={5}>
                                <Box
                                    sx={{
                                        border: '1px solid #ccc',
                                        borderRadius: '4px',
                                        padding: '1px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px',
                                        maxWidth: '100%',
                                        boxSizing: 'border-box',
                                        height: '56px'
                                    }}
                                >
                                    <FormControl component="fieldset">
                                        {/* Checkbox Concluído */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={registroAtual.ensinoConcluido}
                                                        onChange={(e) => handleCheckboxChange(e, 'concluido')}
                                                        name="concluido"
                                                        sx={{ marginLeft: '4px', height: '24px' }}
                                                    />
                                                }
                                                label="Concluído no Ano:"
                                                sx={{
                                                    '.MuiFormControlLabel-label': { fontSize: '0.875rem' },
                                                    marginRight: '8px'
                                                }}
                                            />
                                            {/* Campo de Ano para Concluído */}
                                            {registroAtual.ensinoConcluido && (
                                                <TextField
                                                    name="ensinoConcluidoAno"
                                                    label='Ano'
                                                    value={registroAtual.ensinoConcluidoAno || ''}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ width: '70px', height: '16px' }}
                                                />
                                            )}
                                            {/* Campo de Série para Cursando */}
                                            {registroAtual.ensinoCursando && (
                                                <TextField
                                                    name="ensinoCursandoSerie"
                                                    label="Série"
                                                    value={registroAtual.ensinoCursandoSerie || ''}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    size="small"
                                                    sx={{ width: '70px', height: '16px' }}
                                                />
                                            )}
                                        </Box>

                                        {/* Checkbox Cursando */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={registroAtual.ensinoCursando}
                                                        onChange={(e) => handleCheckboxChange(e, 'cursando')}
                                                        name="cursando"
                                                        sx={{ marginLeft: '4px', height: '24px' }}
                                                    />
                                                }
                                                label="Cursando a Série:"
                                                sx={{
                                                    '.MuiFormControlLabel-label': { fontSize: '0.875rem' },
                                                    marginRight: '8px'
                                                }}
                                            />

                                        </Box>

                                    </FormControl>

                                </Box>

                            </Grid>
                            <Grid item xs={4}>
                                <FormControl variant="outlined" fullWidth>
                                    <InputLabel>Tipo Escola</InputLabel>
                                    <Select
                                        label="Tipo Escola"
                                        name="idTipoEscola"
                                        value={registroAtual.idTipoEscola}
                                        onChange={handleChange}
                                        required
                                    >
                                        {escolas.map((e) => (
                                            <MenuItem key={e.value} value={e.value}>
                                                {e.label}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Responsável Legal / Financeiro */}
                            <Grid item xs={12}>
                                <Typography variant="h6">Responsável Legal / Financeiro</Typography>
                            </Grid>
                            <Grid item xs={8}>
                                <TextField
                                    label="Nome do Responsável Legal / Nome da Empresa"
                                    name="respLegal"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.respLegal}
                                    onChange={handleChange}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    label="CPF / CNPJ"
                                    name="docRespLegal"
                                    variant="outlined"
                                    fullWidth
                                    value={registroAtual.docRespLegal}
                                    onChange={handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setOpenEditDialog(false)} color="primary">Cancelar</Button>
                    <Button onClick={handleSaveRegistro} color="primary">Salvar</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Inscricoes;